import styled from 'styled-components';

export const SectionQuestion = styled.div`
    #title-question {
        font-family: Poppins-Medium, Heltica, Arial, sans-serif;
        color: #505059;
        font-size: 2.6em;
        line-height: 1.5em;
    }

    .btn.btn-secondary {
        background-color: #88888E;
        border-color: #88888E;
    }
`;

export default SectionQuestion;
